import { CartViewResponse } from "@jog/types"

import { handleCartError } from "../helper"
import { JoggApiOption } from "./client"

export const setPaymentCostBase =
    ({ client }: Pick<JoggApiOption, "client">) =>
    async <S extends CartViewResponse>(
        cartId: string,
        version: number,
        paymentName: string,
        centAmount: number
    ): Promise<S> => {
        const request = (version: number) =>
            client.execute({
                uri: `/ctp/carts/${cartId}`,
                method: "POST",
                body: {
                    version,
                    actions: [
                        {
                            action: "addCustomLineItem",
                            name: { en: paymentName, "nl-nl": paymentName },
                            quantity: 1,
                            money: { currencyCode: "EUR", centAmount },
                            slug: paymentName.toLowerCase(),
                            taxCategory: { typeId: "tax-category", key: "vat" },
                        },
                    ],
                },
            })
        return handleCartError(request, version, 5)
    }
